<script>
import { mapActions, mapGetters } from 'vuex'
import LABELS from '@/constants/labels'
import { backgroundList } from '@/constants/data'

export default {
  name: 'Preview',
  data() {
    return {
      allItem: {},
      visible: false,
      routeList: [
        {
          icon: 'x-icon-bg',
          text: '背景',
          name: 'background',
        },
        {
          icon: 'x-icon-person',
          text: 'アバター',
          name: 'select-avatar',
        },
        {
          icon: 'x-icon-text',
          text: 'テキスト',
          name: 'text',
        },
        {
          icon: 'x-icon-stamp',
          text: 'スタンプ',
          name: 'stamp',
        },
      ],
      enableEdit: false,
      selectedItemId: '',
      defaultRotate: 0,
      defaultScale: 0.5,
    }
  },

  methods: {
    ...mapActions('settings', [
      'setLayout',
      'setModules',
      'setExport',
      'setBackground',
      'saveToStorage',
    ]),
    showPopupConfirmDelete() {
      this.$nextTick(() => {
        this.$refs.confirmDeletePopup &&
          this.$refs.confirmDeletePopup.show({
            title: this.mappingLabels.deleteModalTitle,
            message: this.mappingLabels.deleteModalMessage,
            textCancelButton: this.mappingLabels.cancelText,
            textSubmitButton: this.mappingLabels.confirmText,
          })
      })
    },

    resetData() {
      let currentBg = backgroundList[this.getOrientation][0].backgrounds[0]
      this.setModules({ reset: true })
      this.setExport({ reset: true })
      this.setBackground(currentBg)
      this.saveToStorage()
    },

    enableHandleEdit() {
      this.enableEdit = !this.enableEdit
      if (!this.enableEdit) {
        this.selectedItemId = ''
      }
    },

    selectChange(value) {
      this.allItem = { ...this.getTexts, ...this.getStamps, ...this.getAvatars }

      if (value) {
        const currentObject = Object.values(this.allItem).find(
          item => item.id == value
        )
        this.selectedItemId = value

        this.defaultRotate = +currentObject.rotation
        this.defaultScale = +currentObject.scaleX
      } else {
        this.selectedItemId = ''
      }
    },

    handleRotate(value) {
      if (this.selectedItemId.slice(0, 4) == 'text')
        this.handleTextRotate(value)
      else {
        this.allItem[this.selectedItemId].rotation = +value
        this.defaultRotate = +value
      }
    },

    handleScale(value) {
      if (this.selectedItemId.slice(0, 4) == 'text') this.handleTextZoom(value)
      else {
        const currentObject = this.allItem[this.selectedItemId]
        currentObject.scaleX = +value
        currentObject.scaleY = +value

        this.defaultScale = +value
      }
    },

    handleTextRotate(value) {
      if (this.selectedItemId) {
        Object.values(this.getTexts).find(
          item => item.id === this.selectedItemId
        ).rotation = +value
        this.defaultRotate = +value
      }
    },

    handleTextZoom(value) {
      if (this.selectedItemId) {
        const currentObject = Object.values(this.getTexts).find(
          item => item.id === this.selectedItemId
        )
        currentObject.scaleX = +value
        currentObject.scaleY = +value

        this.defaultScale = +value
      }
    },

    handleSaveAll() {
      this.saveToStorage()
      this.enableHandleEdit()
    },

    handleClearData() {
      this.$nextTick(() => {
        this.resetData()
        this.$refs.confirmDeletePopup.hide()
        this.$router.push({ name: 'home' })
      })
    },

    handleIntoExport() {
      this.$nextTick(() => {
        this.$refs.previewLabel.saveImagePreview()
        this.$router.push({ name: 'export' })
      })
    },
  },

  computed: {
    ...mapGetters('settings', [
      'getTemplate',
      'getModules',
      'getBackground',
      'getOrientation',
      'getAvatars',
      'getTexts',
      'getStamps',
    ]),
    mappingLabels() {
      return LABELS
    },
  },
}
</script>

<template>
  <div>
    <s-header>{{ mappingLabels.previewTitle }}</s-header>
    <div class="preview-page">
      <div class="preview-page_container">
        <div class="wrap-content">
          <div class="preview-page_preview">
            <a @click="showPopupConfirmDelete()">
              <div class="btn-delete-img">
                <img :src="require('@/assets/images/avatar/trash_avt.svg')" />
                <span>やり直す</span>
              </div>
            </a>
            <a @click="enableHandleEdit()" v-if="!enableEdit">
              <div class="btn-edit-img">
                <img
                  :src="require('@/assets/images/avatar/edit-preview.png')"
                />
              </div>
            </a>
            <a @click="handleSaveAll()" v-else>
              <div class="btn-edit-img">
                <img
                  :src="require('@/assets/images/avatar/edit-preview-end.png')"
                />
              </div>
            </a>
            <s-preview
              ref="previewLabel"
              :enableDrag="enableEdit"
              :backgroundDraw="getModules.background"
              :textDraw="getModules.texts"
              :stampDraw="getModules.stamps"
              :avatarDraw="getModules.avatars"
              currentMove="all"
              @onchangeSelect="selectChange"
              :selectedName="selectedItemId"
            />
          </div>

          <div class="preview-page_button">
            <div class="preview-page_title">
              <div v-show="enableEdit" class="choose-part-move">
                <img
                  :src="require('@/assets/images/avatar/pointer.png')"
                  alt=""
                />
                移動するパーツを選択してください
              </div>
              <div v-show="selectedItemId" class="show-avatar__input-range">
                <s-range-input
                  :label="'角度'"
                  :min="-180"
                  :max="180"
                  :value="defaultRotate"
                  :step="15"
                  :disabled="!selectedItemId"
                  @on-input="handleRotate"
                />
                <s-range-input
                  :label="'大きさ'"
                  :min="0.25"
                  :max="3"
                  :value="defaultScale"
                  :step="0.01"
                  :disabled="!selectedItemId"
                  @on-input="handleScale"
                />
              </div>
            </div>
            <div v-show="!selectedItemId">
              <s-chatbox page="preview">{{
                mappingLabels.buttonGroupTitle
              }}</s-chatbox>
              <div class="group-btn-option">
                <router-link
                  v-for="(link, index) of routeList"
                  :key="index"
                  class="s-button red-btn btn-option"
                  :to="{ name: link.name }"
                  :title="link.text"
                >
                  <span class="icon-wrap">
                    <component :is="link.icon" />
                  </span>
                  <label>{{ link.text }}</label>
                </router-link>
              </div>
              <a
                class="center-text"
                href="https://www.asahi-gf.co.jp/web-service/asahi-gf/customer/mintia/form.wsp.html?CMD=onForm"
                target="_blank"
                rel="noopener"
                >{{ mappingLabels.linkAsahi }}</a
              >
            </div>
            <div class="last-space"></div>
            <s-navigate-bar
              v-if="!enableEdit"
              class="navigate-bar-fixed"
              :rightOnly="true"
              @rightClick="handleIntoExport"
            >
              {{ mappingLabels.completeText }}</s-navigate-bar
            >
            <s-navigate-bar
              v-else
              class="navigate-bar-fixed"
              @leftClick="$router.go(0)"
              @rightClick="handleSaveAll"
              >{{ mappingLabels.decideAndBackToPreviewText }}
            </s-navigate-bar>
          </div>
        </div>
        <s-modal-confirm
          ref="confirmDeletePopup"
          @submit="handleClearData"
        ></s-modal-confirm>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import 'preview.scss';
</style>
